module.exports = __webpack_public_path__ + "static/media/pause.41f4b6be.svg";